/**
 * Version en ingles de la tienda (ES/EN) sin tocar cada plantilla.
 *
 * Traduce en el navegador los textos de la interfaz: busca el texto en espanol en un diccionario y lo
 * cambia por su version en ingles; lo hace al cargar y cada vez que Vue vuelve a pintar. Los datos de los
 * comercios (nombres de platos, descripciones, categorias propias) se quedan como los escribio el comercio:
 * marca esos elementos con translate="no" para que nunca se toquen.
 *
 * El idioma se elige con el boton ES/EN del encabezado, con ?lang=en en el enlace (para anuncios) o por el
 * ultimo idioma guardado. Por defecto es espanol.
 */
import Vue from 'vue'

const KEY = 'festyLang'

const DICT = {
  // encabezado, menu y carrito
  'Restaurantes': 'Restaurants', 'Licores': 'Liquor', 'Tiendas': 'Stores', 'Servicios': 'Services',
  'Buscar mi dirección': 'Find my address', 'Cambiar de dirección': 'Change address', 'Ingresar': 'Log in',
  'Mi perfil': 'My profile', 'Mis ordenes': 'My orders', 'Mis pedidos': 'My orders', 'Cambiar de ciudad': 'Change city',
  'Cerrar sesión': 'Log out', 'Iniciar sesión': 'Log in', 'Carrito de compras': 'Shopping cart', 'Realizar Pedido': 'Place order',
  'Productos': 'Products', 'Subtotal:': 'Subtotal:', 'Perfil de usuario': 'User profile', 'Cerrar': 'Close', 'Editar': 'Edit',
  'Ingrese la dirección donde desea recibir su pedido': 'Enter the address where you want to receive your order',
  'Econtraremos comercios cerca a su dirección': 'We will find stores near your address', 'Ver comercios': 'See stores',
  'Nueva dirección': 'New address', 'Sugerencia:': 'Tip:', 'Puede arrastrar el marcador para ajustar su dirección': 'You can drag the marker to adjust your address',
  'Guardar': 'Save', 'Direcciones': 'Addresses', 'Agregar dirección': 'Add address', 'Buscar comercio': 'Search stores', 'Buscar producto': 'Search products',
  'Nombre': 'Name', 'Email': 'Email', 'Teléfono': 'Phone', 'Ingrese su dirección': 'Enter your address',
  'Importante para llegar más rapido': 'Important to arrive faster', 'Apt, torre, piso x, edificio': 'Apt, tower, floor, building',
  'Ejemplo: Mi casa, Mi oficina, Empresa': 'Example: My home, My office, Company',
  // bot
  'Pide por chat a cualquier comercio': 'Order by chat from any store', 'Pedido': 'Order', 'Ver mis pedidos': 'View my orders',
  'Pedir por chat': 'Order by chat', 'Empezar de nuevo': 'Start over', 'Escribe qué quieres pedir…': 'Type what you want to order…', 'Enviar': 'Send',
  'Hola, soy Festy Bot. Dime qué se te antoja o de qué comercio quieres pedir y te armo el pedido.': 'Hi, I am Festy Bot. Tell me what you feel like eating or which store you want to order from and I will build your order.',
  // ciudad
  'Elige tu ciudad': 'Choose your city', 'Pide fácil, rápido y seguro en Festy.': 'Order easily, fast and safely on Festy.',
  // inicio
  'Todo': 'All', 'Hoy en Festy': 'Today on Festy', 'Elige un comercio': 'Choose a store', 'No pudimos cargar los comercios': 'We could not load the stores',
  'Revisa tu conexión e inténtalo de nuevo.': 'Check your connection and try again.', 'Reintentar': 'Retry', 'No encontramos comercios': 'We found no stores',
  'Prueba con otra categoría o borra la búsqueda.': 'Try another category or clear the search.', 'Ver todos': 'See all',
  'Ver menú completo': 'See full menu', 'Se antoja hoy': 'Craving today', 'Platos de todos los comercios': 'Dishes from all stores',
  '¿Prefieres escribir? Pide por chat a cualquier comercio.': 'Prefer to type? Order by chat from any store.',
  'Dile qué se te antoja. El bot arma tu pedido con los precios reales y lo envía al comercio.': 'Tell it what you feel like. The bot builds your order with real prices and sends it to the store.',
  'Abrir el chat': 'Open the chat', 'Para comercios': 'For businesses', '¿Vendes productos? Crea tu tienda en línea.': 'Do you sell products? Create your online store.',
  'Registrar mi comercio': 'Register my business', 'Pedir': 'Order', 'Destacado': 'Featured', 'Anterior': 'Previous', 'Siguiente': 'Next',
  'Cargando comercios': 'Loading stores', 'Platos de hoy': 'Today\'s dishes', 'Mediterránea': 'Mediterranean', 'Parrilla': 'Grill',
  'Nuevas categorías:': 'New categories:', 'NUEVOS': 'NEW', 'CERCANOS': 'NEARBY', 'DOMI $0': 'FREE DELIVERY', 'Categorías': 'Categories', 'Destacados': 'Featured',
  'Agregar': 'Add', 'VER MÁS': 'SEE MORE', 'Exclusivo': 'Exclusive', 'DOMICILIO:': 'DELIVERY:', 'Ver más': 'See more', 'Ver menos': 'See less',
  'Aún no hay productos de esta categoría en tu zona, pero pronto encontraras las mejores promociones.': 'There are no products in this category in your area yet, but you will soon find great deals.',
  'Aún no hay comercios de esta categoría en tu zona, pero pronto encontraras las mejores promociones.': 'There are no stores in this category in your area yet, but you will soon find great deals.',
  // pagina del comercio
  'Menú': 'Menu', 'Acompañantes': 'Sides', 'Bebidas': 'Drinks', 'Abierto': 'Open', 'Cerrado': 'Closed', 'Saber más': 'About',
  'Imágenes de referencia': 'Reference images', 'Compartir': 'Share', 'El comercio no tiene calificaciones aún.': 'This store has no ratings yet.', 'Información': 'Information',
  'No encontramos el comercio que buscas. 😬': 'We could not find the store you are looking for. 😬', 'Secciones del menú': 'Menu sections',
  // login
  'Formulario de ingreso': 'Log-in form', 'Crear cuenta': 'Create account', '¿Olvidaste tu contraseña?': 'Forgot your password?', 'Regresar': 'Back',
  'Recuperar contraseña': 'Recover password', 'Nueva cuenta': 'New account', 'He leído y acepto los': 'I have read and accept the',
  'términos y condiciones del servicio': 'terms and conditions of service', 'Clic para ver términos y condiciones': 'Click to read the terms and conditions',
  'Correo electrónico': 'Email', 'Contraseña': 'Password', 'Nombre completo': 'Full name', 'E-mail': 'Email', 'Celular': 'Mobile phone',
  'Por favor ingrese la dirección de correo electrónico que utilizó en el registro para que podamos enviarle un enlace de restablecimiento de contraseña.': 'Please enter the email address you used to sign up so we can send you a link to reset your password.',
  // mis pedidos
  'TUS PEDIDOS': 'YOUR ORDERS', 'TOTAL:': 'TOTAL:', 'Cancelado': 'Cancelled', 'Creado': 'Created', 'Preparando': 'Preparing', 'En camino': 'On the way', 'Entregado': 'Delivered',
  'Tu pago está siendo procesado por la pasarela.': 'Your payment is being processed by the payment gateway.',
  'Pago pendiente, realiza la tranferencia y adjunta el comprobante para completar tu pedido': 'Payment pending: make the transfer and attach the receipt to complete your order',
  'Ver opciones de pago': 'See payment options', 'Items por página': 'Items per page', 'Página': 'Page', 'de': 'of', 'Ayuda': 'Help',
  'Llamar al comercio': 'Call the store', 'Contactar a Festy Soporte': 'Contact Festy Support', 'Tienda:': 'Store:', 'Pedido:': 'Order:', 'Promo:': 'Promo:', 'Total:': 'Total:',
  'Teléfono:': 'Phone:', 'Entregar en:': 'Deliver to:', 'Valor del domicilio:': 'Delivery fee:', 'Notas:': 'Notes:', 'Calificación:': 'Rating:',
  '¿Cómo fue tu experiencia?': 'How was your experience?', 'Pago': 'Payment', 'Banco:': 'Bank:', 'Cuenta #:': 'Account #:', 'Comprobante': 'Receipt',
  'El comprobante no ha sido enviado': 'The receipt has not been sent', 'Calificar': 'Rate', 'Comprobante de pago': 'Payment receipt',
  'Clic aquí para adjuntar': 'Click here to attach', 'Comentarios': 'Comments',
  // confirmar pedido
  'CONFIRMAR PEDIDO': 'CONFIRM ORDER', 'ELIGE UNA DIRECCIÓN GUARDADA O CREA UNA': 'CHOOSE A SAVED ADDRESS OR CREATE ONE', 'Cambiar dirección': 'Change address',
  'RESUMEN': 'SUMMARY', 'SUBTOTAL': 'SUBTOTAL', 'DOMICILIO': 'DELIVERY', 'COSTO DE PAGO EN LÍNEA': 'ONLINE PAYMENT FEE', 'TOTAL': 'TOTAL', 'MÉTODO DE PAGO': 'PAYMENT METHOD',
  'Pago en línea': 'Pay online', '(tarjeta, PSE, Nequi)': '(card, PSE, Nequi)', 'Transferencia:': 'Bank transfer:', 'Efectivo': 'Cash', 'Datáfono(T. Credito / Debito)': 'Card reader (credit / debit)',
  'Una vez realices tu pedido prodrás ver las cuentas y adjuntar el comprobante para que el negocio reciba tu pedido': 'Once you place your order you will see the accounts and can attach the receipt so the store receives your order',
  'Al presionar "Realizar pedido" irás a Wompi para pagar de forma segura. El costo del pago en línea se suma al total. Tu pedido llega al comercio cuando el pago sea aprobado.': 'When you press "Place order" you will go to Wompi to pay securely. The online payment fee is added to the total. Your order reaches the store once the payment is approved.',
  'El 100% va para quien te entrega. Es opcional.': '100% goes to the person delivering to you. It is optional.', 'Sin propina': 'No tip', 'Otro valor': 'Other amount',
  'PROPINA PARA EL DOMICILIARIO': 'TIP FOR THE DELIVERY PERSON', 'Propina para el domiciliario': 'Tip for the delivery person',
  '¿TIENES UN CUPÓN DE DESCUENTO?': 'DO YOU HAVE A DISCOUNT COUPON?', 'Agregar cupón': 'Add coupon', 'Realizar pedido': 'Place order', 'Revisar el carrito': 'Review the cart',
  'Nueva Dirección': 'New address', 'Guardar dirección': 'Save address', 'Confirmar pedido': 'Confirm order',
  'Solo nos falta tu confirmación, ¿Tienes la dirección y los demás datos correctos?, si lo crees necesario escribe el barrio e indicaciones para el domiciliario en la caja de comentarios': 'We just need your confirmation. Are the address and other details correct? If needed, write your neighborhood and directions for the delivery person in the comments box',
  'NO, REVISAR': 'NO, REVIEW', 'SI, REALIZAR PEDIDO': 'YES, PLACE ORDER', 'Aplicar cupón de descuento': 'Apply discount coupon', 'CERRAR': 'CLOSE', 'APLICAR': 'APPLY',
  'Dirección': 'Address', 'Ejemplo: Calle 22 # 18 - 07': 'Example: 22nd Street # 18 - 07', 'Barrio': 'Neighborhood', 'Cupón de decuento': 'Discount coupon', 'Ejemplo: XYZ3K': 'Example: XYZ3K',
  '¿Cuánto quieres darle al domiciliario?': 'How much would you like to give the delivery person?', 'Monto de la propina': 'Tip amount',
  // resultado del pago
  'Confirmando tu pago…': 'Confirming your payment…', 'Esto tarda unos segundos. No cierres esta página.': 'This takes a few seconds. Please do not close this page.',
  '¡Pago recibido!': 'Payment received!', 'Tu pedido fue enviado a': 'Your order was sent to', 'Total pagado:': 'Total paid:', 'Tu pago está en proceso': 'Your payment is being processed',
  'Algunos pagos, como PSE, tardan unos minutos en confirmarse. Cuando se apruebe, tu pedido llegará al comercio.': 'Some payments, such as PSE, take a few minutes to confirm. Once approved, your order will reach the store.',
  'Actualizar estado': 'Refresh status', 'El pago no fue aprobado': 'The payment was not approved', 'No te cobramos nada. Puedes intentarlo de nuevo con otro medio de pago.': 'You were not charged. You can try again with another payment method.',
  'Reintentar el pago': 'Retry payment', 'No pudimos revisar tu pago': 'We could not check your payment', 'Intentar de nuevo': 'Try again',
  // pie
  'Copyright ©': 'Copyright ©', 'Consíguelo en el': 'Get it on the'
}

// textos con numeros o nombres: se comparan con una expresion y se arma la frase en ingles
const RULES = [
  [/^(\d+) comercios?$/, (m) => `${m[1]} ${m[1] === '1' ? 'store' : 'stores'}`],
  [/^(\d+) productos?$/, (m) => `${m[1]} ${m[1] === '1' ? 'item' : 'items'}`],
  [/^(\d+) productos? en tu pedido$/, (m) => `${m[1]} ${m[1] === '1' ? 'item' : 'items'} in your order`],
  [/^(\d+) pedidos?$/, (m) => `${m[1]} ${m[1] === '1' ? 'order' : 'orders'}`],
  [/^Pagos: Efectivo, (.*)$/, (m) => `Payments: Cash, ${m[1]}`],
  [/^Pedir en (.+)$/, (m) => `Order from ${m[1]}`, true],
  [/^Agregar (.+)$/, (m) => `Add ${m[1]}`, true],
  [/^Agregar uno de (.+)$/, (m) => `Add one ${m[1]}`, true],
  [/^Quitar uno de (.+)$/, (m) => `Remove one ${m[1]}`, true],
  [/^Ver (.+)$/, (m) => `View ${m[1]}`, true],
  [/^Ir a (.+)$/, (m) => `Go to ${m[1]}`, true],
  [/^Logo de (.+)$/, (m) => `${m[1]} logo`, true],
  [/^DOMICILIO: (.+)$/, (m) => `DELIVERY: ${m[1]}`],
  [/^Pedido #(\w+)$/, (m) => `Order #${m[1]}`],
  [/^Este plato es de (.+)\. Se enviará como pedido aparte\.$/, (m) => `This dish is from ${m[1]}. It will be sent as a separate order.`],
  [/^Ya tienes productos de (.+) en el carrito de compras.*$/, (m) => `You already have items from ${m[1]} in your cart. Finish that order first.`],
  [/^PROPINA PARA EL DOMICILIARIO \((.+)\)$/, (m) => `TIP FOR THE DELIVERY PERSON (${m[1]})`],
  [/^Propina para el domiciliario \((.+)\)$/, (m) => `Tip for the delivery person (${m[1]})`],
]

const state = Vue.observable({ locale: 'es' })
const origText = new WeakMap() // nodo -> texto en espanol
const lastWritten = new WeakMap() // nodo -> ultimo texto en ingles que escribimos
const ATTRS = ['placeholder', 'aria-label', 'title', 'alt']

function translate (str, attr) {
  const m = str.match(/^(\s*)([\s\S]*?)(\s*)$/)
  const core = m[2].replace(/\s+/g, ' ')
  if (!core) return null
  let out = DICT[core]
  if (out == null) {
    for (const [re, fn, attrOnly] of RULES) {
      if (attrOnly && !attr) continue
      const hit = core.match(re)
      if (hit) { out = fn(hit); break }
    }
  }
  return out == null ? null : m[1] + out + m[3]
}

const skipped = (el) => {
  for (let n = el; n && n.nodeType === 1; n = n.parentNode) {
    if (n.getAttribute && n.getAttribute('translate') === 'no') return true
    const t = n.tagName
    if (t === 'SCRIPT' || t === 'STYLE' || t === 'NOSCRIPT' || t === 'TEXTAREA') return true
  }
  return false
}

function handleText (node) {
  if (skipped(node.parentNode)) return
  const current = node.nodeValue
  if (lastWritten.get(node) === current) return // lo escribimos nosotros
  origText.set(node, current)
  if (state.locale !== 'en') return
  const en = translate(current)
  if (en != null && en !== current) {
    lastWritten.set(node, en)
    node.nodeValue = en
  }
}

function handleAttrs (el) {
  if (!el.getAttribute || skipped(el)) return
  const saved = el.__festyAttrs || (el.__festyAttrs = {})
  for (const a of ATTRS) {
    if (!el.hasAttribute(a)) continue
    const v = el.getAttribute(a)
    if (saved[a] && saved[a].en === v) continue
    saved[a] = { es: v, en: v }
    if (state.locale === 'en') {
      const en = translate(v, true)
      if (en != null && en !== v) { saved[a].en = en; el.setAttribute(a, en) }
    }
  }
}

function walk (root) {
  if (!root) return
  if (root.nodeType === 3) return handleText(root)
  if (root.nodeType !== 1) return
  handleAttrs(root)
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT)
  let n = walker.nextNode()
  while (n) {
    if (n.nodeType === 3) handleText(n)
    else handleAttrs(n)
    n = walker.nextNode()
  }
}

function restore () {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT)
  let n = walker.nextNode()
  while (n) {
    if (n.nodeType === 3) {
      const es = origText.get(n)
      if (es != null && lastWritten.get(n) === n.nodeValue) { n.nodeValue = es; lastWritten.delete(n) }
    } else if (n.__festyAttrs) {
      for (const a of Object.keys(n.__festyAttrs)) {
        if (n.getAttribute(a) === n.__festyAttrs[a].en) n.setAttribute(a, n.__festyAttrs[a].es)
      }
    }
    n = walker.nextNode()
  }
}

let observer = null
function startObserver () {
  if (observer || typeof MutationObserver === 'undefined') return
  observer = new MutationObserver((records) => {
    for (const r of records) {
      if (r.type === 'characterData') handleText(r.target)
      else if (r.type === 'attributes') handleAttrs(r.target)
      else r.addedNodes.forEach(walk)
    }
  })
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS })
}

export function setLocale (locale) {
  const next = locale === 'en' ? 'en' : 'es'
  state.locale = next
  try { window.localStorage.setItem(KEY, next) } catch (e) { /* sin almacenamiento */ }
  document.documentElement.lang = next
  if (next === 'en') walk(document.body)
  else restore()
  if (window.festyTrack) window.festyTrack('language_change', { language: next })
}

export function currentLocale () { return state.locale }

export function initI18n () {
  let initial = 'es'
  try {
    const q = new URLSearchParams(window.location.search).get('lang')
    initial = q === 'en' || q === 'es' ? q : window.localStorage.getItem(KEY) || 'es'
    if (q === 'en' || q === 'es') window.localStorage.setItem(KEY, q) // el idioma del enlace queda guardado
  } catch (e) { /* sin almacenamiento */ }
  state.locale = initial === 'en' ? 'en' : 'es'
  document.documentElement.lang = state.locale
  startObserver()
  if (state.locale === 'en') walk(document.body)
  // para el boton del encabezado
  Vue.prototype.$lang = state
  Vue.prototype.$setLocale = setLocale
}
